import { render, staticRenderFns } from "./r-title.vue?vue&type=template&id=15bc039c&"
import script from "./r-title.vue?vue&type=script&lang=js&"
export * from "./r-title.vue?vue&type=script&lang=js&"
import style0 from "./r-title.vue?vue&type=style&index=0&id=15bc039c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports